/**
 * Registers the minimal service worker (public/sw.js).
 *
 *  - Production builds only (no service worker in development).
 *  - REACT_APP_DISABLE_SW=true is the kill switch: at the next build the worker is
 *    unregistered instead of registered.
 *  - Any failure is swallowed: the site works exactly as before without it.
 *  - Updates: the browser re-checks /sw.js on navigation; on top of that the app asks
 *    for a check when it comes back to the foreground, at most once an hour.
 */
export const SW_URL = '/sw.js';
const UPDATE_CHECK_MS = 60 * 60 * 1000;

export function registerServiceWorker({ nav = navigator, win = window, doc = document, env = process.env } = {}) {
  if (!nav || !('serviceWorker' in nav)) return;
  if (env.REACT_APP_DISABLE_SW === 'true') {
    nav.serviceWorker.getRegistrations?.()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
    return;
  }
  if (env.NODE_ENV !== 'production') return;

  const start = () => {
    nav.serviceWorker.register(SW_URL, { scope: '/', updateViaCache: 'none' })
      .then((reg) => {
        let last = Date.now();
        doc.addEventListener('visibilitychange', () => {
          if (doc.visibilityState === 'visible' && Date.now() - last > UPDATE_CHECK_MS) {
            last = Date.now();
            reg.update().catch(() => {});
          }
        });
      })
      .catch(() => { /* no service worker: nothing else changes */ });
  };
  if (doc.readyState === 'complete') start();
  else win.addEventListener('load', start, { once: true });
}
